"use client";

import { Scale } from "@/animations/scale";
import imgBgZkStarter from '@/assets/bg/bg_zkStarter.png';
import Image from '@/components/Image';
import { cn } from "@/utils";
import { formatNumber } from "@/utils/number-format";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { useMemo, useState } from "react";
import { useZkStarter } from "../apis/zkstarter";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";
import { ModalZKStarter } from "../Menu/modals/ModalZKStarter";

// xs: "max-w-[80%] ml-[14px] mt-[32px]",
// sm: "max-w-[80%] ml-[14px] mt-[32px]",
// md: "max-w-[80%] ml-[14px] mt-[32px]",
// lg: "max-w-[555px] ml-[32px] mt-[32px]",
// xl: "max-w-[511px] ml-[262px] -mt-[233px]",
// "2xl": "max-w-[543px] ml-[278px] -mt-[248px]",
// "3xl": "max-w-[575px] ml-[295px] -mt-[263px]",
const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[80%] ml-[14px] mt-[32px]",
      sm: "max-w-[80%] ml-[14px] mt-[32px]",
      md: "max-w-[80%] ml-[14px] mt-[32px]",
      lg: "max-w-[555px] ml-[32px] mt-[32px]",
      xl: "max-w-[511px] ml-[262px] -mt-[103px]",
      "2xl": "max-w-[543px] ml-[278px] -mt-[108px]",
      "3xl": "max-w-[575px] ml-[295px] -mt-[123px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderZkStarter() {
  const { twSize, width } = useResize();

  const { data } = useZkStarter();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const useCommitted = useMemo(() => {
    if (!data) {
      return "--";
    }
    let total = 0;

    data.forEach((e) => {
      total = total + e.totalUser;
    });
    const temp = formatNumber(total);
    return `${temp.value}${temp.text ? temp.text + "+" : ""}`;
  }, [data]);

  return (
    <>
      {' '}
      <Scale>
        <WrapperFinder className={cn(variants({ twSize: twSize }))}>
          <HeaderFinder>
            <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
              Holdstaion zkStarter
            </p>
          </HeaderFinder>

          <div className="">
            <div className="p-5 pb-0 pr-0 md:pr-5">
              <div
                style={{
                  backgroundImage: `url(${imgBgZkStarter})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'bottom right',
                  backgroundSize: width >= 1024 ? '365px auto' : '265px auto',
                }}
                className="pb-5"
              >
                <div>
                  <p className="text-xl lg:text-[1.75rem] lg:leading-[2.5rem] font-medium pr-5">
                    A launch hub for projects, investors, and community,{' '}
                    <span className="text-[#777E90]">
                      driving the success of ZKsync with a fair participation
                      mechanism.
                    </span>
                  </p>
                </div>

                <div className="flex flex-col gap-4 md:gap-6 lg:gap-10 pt-10 md:pt-10">
                  <div>
                    <p className="text-[1.625rem] leading-7 lg:text-[40px] lg:leading-[3rem] font-medium text-[#12AD62]">
                      {useCommitted}
                    </p>
                    <p className="text-[13px] leading-5 lg:text-base font-medium text-[#777E90]">
                      User Committed
                    </p>
                  </div>

                  <div>
                    <p className="text-[1.625rem] leading-7 lg:text-[40px] lg:leading-[3rem] font-medium text-[#12AD62]">
                      $8.8M+
                    </p>
                    <p className="text-[13px] leading-5 lg:text-base font-medium text-[#777E90]">
                      Total Volume
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-[40px_1fr_112px] lg:grid-cols-[48px_1fr_112px] gap-2.5 lg:gap-4 p-4">
              <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl flex-shrink-0">
                <Image
                  src={require('@/assets/icons/ic_zkstarter.png')}
                  width={512}
                  height={512}
                  alt="swap"
                />
              </div>

              <div className="flex flex-col justify-center">
                <p className="text-sm font-medium text-[#141416] line-clamp-1">
                  Holdstation zkStarter
                </p>
                <p className="text-sm font-medium text-[#777E90] line-clamp-1">
                  First launchpad on ZKsync
                </p>
              </div>
              <div className="flex items-center justify-end">
                <button
                  type="button"
                  className={clsx(
                    'px-6 py-2.5 rounded-full bg-black',
                    'text-sm text-white font-medium whitespace-nowrap',
                  )}
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  View More
                </button>
              </div>
            </div>
          </div>
        </WrapperFinder>
      </Scale>
      {isOpen ? (
        <ModalZKStarter
          onClose={() => {
            setIsOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
